import React, { useEffect, useState } from 'react';

function FacebookComments() {
	const [isLoggedIn, setIsLoggedIn] = useState(true);

	useEffect(() => {
		console.log('Loading FACEBOOK COMMENTS');
		loadFacebookSDK();

		window.fbAsyncInit = function() {
			FB.init({
				xfbml: true,
				version: 'v20.0',
				cookie: true,
				appId: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
			});

			// Wait for Facebook to render the comments plugin
			setTimeout(checkIfLoggedIn, 1000);
		};
	}, []);

	const checkIfLoggedIn = () => {
		const iframe = document.querySelector('.fb-comments > span > iframe');
		if (iframe && iframe.offsetHeight <= 1) {
			setIsLoggedIn(false);
		}
	};

	const style = {
		display: 'flex',
		justifyContent: 'center',
		maxWidth: '600px',
		margin: '0 auto',
		border: '1px solid lightgray',
		flexDirection:'column'
	};

	return (
		<div>
			<div id="fb-root"></div>
			{isLoggedIn ? (
				<div className="fb-comments" style={style}
					 data-href={window.location.toString()}
					 data-width="100%"
					 data-numposts="5">
				</div>
			) : (
				<div style={style}>
					<p style={{textAlign:'center'}}>Logg inn på <a target={"_blank"} href={'https://facebook.com'}>Facebook</a> for å se kommentarer.</p>
				</div>
			)}
		</div>
	);
}

export default FacebookComments;

function loadFacebookSDK() {
	if (!window.FB) {
		(function(d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) { return; }
			js = d.createElement(s); js.id = id;
			js.src = "https://connect.facebook.net/nb_NO/sdk.js#xfbml=1&version=v20.0";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
	}
}
